import { createUseStyles, useTheme } from 'react-jss'
import style from './style'
import {
  TypographyElement,
  Avatar,
  Icon,
  Icons,
  RateStars,
  Paper,
  Button,
  ButtonVariation,
  ButtonSize,
  Container
} from 'UI'
import { useEffect, useRef } from 'react'
import Text from './text.json'
import EntrepriseOffer from '../EntrepriseOffer'
import BoostCareer from '../BoostCareer'
import { TrainerPrimaryPath } from 'navigation/Routes'
import SmartTableOfContent from '../SmartTableOfContent'
import { FacebookShareLink, TwitterShareLink, LinkdinShareLink, ProfileTypes } from 'constants/'
import { useParams } from 'react-router'
import SmartVideoPlayer from '../SmartVideoPlayer'
import SocialMedia from 'components/common/SocialMedia'
import { signin } from 'identity/userManager'

const useStyle = createUseStyles(style)

export default ({
  Title,
  AuthorFirstName = '',
  AuthorLastName = '',
  AuthorPhoto,
  AuthorId,
  LevelId,
  Rating,
  ReviewersCount,
  goToTrainer,
  Price,
  CurrencyId,
  showPopUp,
  showPopUpAction,
  IsAccessible,
  addToCart,
  Id,
  Image,
  MobileImageUrl,
  ViewersCount,
  Duration,
  Slug,
  AlternativePrice,
  PricePromo,
  AlternativePricePromo,
  ProfileType,
  scrollToPricing,
  isFree
}) => {
  const theme = useTheme()
  const {
    popup,
    title,
    infosAndButton,
    infos,
    button,
    videoAndTableOfContents,
    video,
    tableOfContents,
    icons,
    rateStarsClass,
    closeIcons,
    innerPopUp,
    priceAndCurrency,
    priceAndCurrencyDiscount,
    videoAndSubInfos,
    subInfos,
    socialMedia,
    priceContainer
  } = useStyle()
  const { videoSlug } = useParams()
  useEffect(() => { showPopUpAction(!!videoSlug) }, [])
  const escAndEnterFunction = ({ keyCode }) => keyCode === 27 && showPopUpAction(false)
  useEffect(() => {
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keydown', escAndEnterFunction)
    return () => {
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keydown', escAndEnterFunction)
    }
  }, [])
  const node = useRef()
  const handleClick = e => node && node.current && !node.current.contains(e.target) && showPopUpAction(false)
  return (
    showPopUp
      ? (
        <div className={popup}>
          <Container>
            <div className={innerPopUp} ref={node}>
              <div className={title}>
                <TypographyElement
                  variant='body1'
                  color={theme.neutral[100]}
                >
                  {Title}
                </TypographyElement>
                <Icon iconName={Icons.close} style={closeIcons} onHandleIconClick={() => showPopUpAction(false)} />
              </div>
              <Paper noHover className={infosAndButton}>
                <div className={infos}>
                  <Avatar
                    width={28}
                    height={28}
                    widthTablet={28}
                    heightTablet={28}
                    widthMobile={28}
                    heightMobile={28}
                    img={AuthorPhoto}
                    name={`${AuthorFirstName[0]}${AuthorLastName[0]}`}
                    handleClick={() => goToTrainer(AuthorId)}
                  />
                  <TypographyElement
                    variant='heading6'
                    color={theme.primary[0]}
                    spacing='0 16px 0 8px'
                    Component='a'
                    href={`${TrainerPrimaryPath}/${AuthorId}`}
                    handleClick={() => goToTrainer(AuthorId)}
                    cursor='pointer'
                  >
                    {`${AuthorFirstName} ${AuthorLastName.toUpperCase()}`}
                  </TypographyElement>
                  <Icon iconName={Icons.dashboard} style={icons} />
                  <TypographyElement
                    variant='body1'
                    spacing='0 16px 0 8px'
                  >
                    {LevelId}
                  </TypographyElement>
                  {
                    !!Rating &&
                    (
                      <>
                        <Icon iconName={Icons.review} style={icons} />
                        <RateStars value={Rating} className={rateStarsClass} secondary />
                        <TypographyElement
                          variant='caption'
                          spacing='0 16px 0 2px'
                        >
                          {`(${ReviewersCount})`}
                        </TypographyElement>
                      </>)
                  }
                  {
                    !IsAccessible && (ProfileType && ProfileType !== ProfileTypes.Default && ProfileType !== ProfileTypes.FreeSubscriber) && (
                      <>
                        <Icon iconName={Icons.shoppingCart} style={icons} />
                        <div className={priceContainer}>
                          <TypographyElement
                            variant='body1'
                            display='flex'
                            color={PricePromo ? theme.error[0] : theme.primary[0]}
                            spacing='0 0 0 8px'
                            className={priceAndCurrency}
                          >
                            {AlternativePricePromo || AlternativePrice || Price}
                            <TypographyElement
                              Component='span'
                              variant='caption'
                              spacing='0 0 0 2px'
                              color={PricePromo ? theme.error[0] : theme.primary[0]}
                            >
                              {CurrencyId}
                            </TypographyElement>
                          </TypographyElement>
                          {
                            (AlternativePricePromo || PricePromo)
                              ? (
                                <TypographyElement
                                  variant='body1'
                                  display='flex'
                                  spacing='0 0 0 8px'
                                  className={priceAndCurrencyDiscount}
                                >
                                  {AlternativePrice || Price}
                                  <TypographyElement
                                    Component='span'
                                    variant='caption'
                                    spacing='0 0 0 2px'
                                  >
                                    {CurrencyId}
                                  </TypographyElement>
                                </TypographyElement>
                                )
                              : null
                          }
                        </div>
                      </>
                    )
                  }
                </div>
                <div className={button}>
                  {
                    !ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber
                      ? (
                        <Button
                          variation={ButtonVariation.primary}
                          size={ButtonSize.small}
                          label={Text.accessTheTraining}
                          width='100%'
                          onHandleClick={() => {
                            if (!isFree) {
                              showPopUpAction(false)
                              scrollToPricing()
                            } else signin()
                          }}
                        />
                        )
                      : (
                        <Button
                          variation={ButtonVariation.primary}
                          size={ButtonSize.small}
                          label={Text.addToCart}
                          onHandleClick={() => addToCart({
                            Image,
                            MobileImageUrl,
                            Title,
                            Price,
                            Id,
                            Rating,
                            ReviewersCount,
                            Duration,
                            ViewersCount,
                            Slug,
                            AlternativePrice,
                            PromotionPrice: PricePromo,
                            AlternativePricePromo
                          })}
                          width='100%'
                        />
                        )
                  }
                </div>
              </Paper>
              <Paper className={videoAndTableOfContents}>
                <div className={videoAndSubInfos}>
                  <div className={video}>
                    <SmartVideoPlayer />
                  </div>
                  <div className={subInfos}>
                    <BoostCareer />
                    <EntrepriseOffer altText noMargin />
                  </div>
                </div>
                <div className={tableOfContents}>
                  <SmartTableOfContent
                    expandAll
                    handleLockedVideoClick={() => {
                      if (!ProfileType || ProfileType === ProfileTypes.Default || ProfileType === ProfileTypes.FreeSubscriber) {
                        showPopUpAction(false)
                        scrollToPricing()
                      }
                    }}
                  />
                </div>
              </Paper>
              <div className={socialMedia}>
                <SocialMedia
                  title={Text.shareOnSocialMedia}
                  textProps={{
                    color: theme.secondary[500],
                    variant: 'body2'
                  }}
                  shareLinks={{
                    facebookShareLink: FacebookShareLink,
                    twitterShareLink: TwitterShareLink,
                    linkedinShareLink: LinkdinShareLink
                  }}
                />
              </div>
            </div>
          </Container>
        </div>
        )
      : null
  )
}
